import React from "react";
import { Button } from "@cmp-src/primitives/button";
import { useTranslation } from "react-i18next";

const classes = {
  Wrapper: "flex w-full justify-between align-center px-1",
  CancelButtonLabel: "font-semibold text-content text-xs uppercase",
  ConfirmButtonLabel: "font-semibold text-primary-800 text-xs uppercase",
  Button: "border-0"
};

export interface ModalButtonsProps {
  /** Shows Apply on the right. */
  onApply?: () => Promise<void> | void;
  /** Shows Clear on the left. */
  onCancel?: () => Promise<void> | void;
}

/** The Clear / Apply bar at the bottom of filter popovers. */

export const ModalButtons: React.FC<ModalButtonsProps> = ({
  onApply,
  onCancel
}) => {
  const { t } = useTranslation("common");

  return (
    <div className={classes.Wrapper}>
      {onCancel ? (
        <Button
          variant="ghost"
          className={classes.Button}
          onClick={onCancel}
          labelClassName={classes.CancelButtonLabel}
        >
          {t("modalActions.clear")}
        </Button>
      ) : (
        <div />
      )}
      {onApply ? (
        <Button
          variant="ghost"
          className={classes.Button}
          onClick={onApply}
          labelClassName={classes.ConfirmButtonLabel}
        >
          {t("modalActions.apply")}
        </Button>
      ) : (
        <div />
      )}
    </div>
  );
};
